import React from 'react';
import {connect} from 'react-redux';

import {AppState} from '../Store';
import {Dashboard as DashboardModel} from '../Services/DashboardService';

import ViewChart from './ViewChart';

interface DashboardProps {
  dashboard: DashboardModel;
}

function Dashboard({dashboard}: DashboardProps) {
  const {articles, authors, categories} = dashboard;

  return (
    <div>
      <div className="row">
        <div className="col-md-6 col-lg-4">
          <ViewChart title="Article Views" data={articles.views} />
        </div>
        <div className="col-md-6 col-lg-4">
          <ViewChart title="Author Views" data={authors.views} />
        </div>
        <div className="col-md-6 col-lg-4">
          <ViewChart title="Category Views" data={categories.views} />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state: AppState) => {
  return {
    dashboard: state.admin.dashboard,
  };
};

export default connect(mapStateToProps)(Dashboard);
